import React from 'react';
import { Pill } from './Pill';
interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowTone?: 'green' | 'gold' | 'alert' | 'outline';
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  eyebrowTone = 'green',
  title,
  lead,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl';
  return <div className={`${alignment} ${className}`} data-id="element-196" data-mp="gj6tn7p8f7hd">
      {eyebrow ? <Pill tone={eyebrowTone} data-id="element-197" data-mp="glj99e7ip5r9">{eyebrow}</Pill> : null}
      <h2 className={`font-display text-[1.9rem] font-bold leading-[1.12] text-ink sm:text-[2.3rem] lg:text-[2.6rem] ${eyebrow ? 'mt-5' : ''}`} data-id="element-198" data-mp="1vbzrnzhmx2p">
        {title}
      </h2>
      {lead ? <p className={`mt-4 font-sans text-base leading-relaxed text-muted ${align === 'center' ? 'mx-auto max-w-readable' : 'max-w-readable'}`} data-id="element-199" data-mp="ujhkwbugeo32">
          {lead}
        </p> : null}
    </div>;
}